<template>
  <div v-if="isExpired" class="news-promo-tag">Акция завершена</div>
</template>

<script>
export default {
  props: {
    promoEnd: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentDate: null,
    };
  },
  computed: {
    isExpired() {
      if (!this.promoEnd || !this.currentDate) return false;
      const promoDate = new Date(Date.parse(this.promoEnd.replace(" ", "T")));
      return promoDate < this.currentDate;
    },
  },
  mounted() {
    this.currentDate = new Date();
  },
};
</script>

<style scoped>
.news-promo-tag {
  padding: 10px 15px;
  width: fit-content;
  font-size: 14px;
  font-weight: 300;
  color: #ffffff;
  background-color: #c45e45;
  text-wrap: nowrap;
}
</style>
